import { EdState } from "@/ed";
import { loadOrDefault } from "@/utils/utils";
import { useCallback, useEffect, useState } from "react";
import { Desktop } from "./Desktop";
import { DesktopState } from "./desktopState";
import { Scenario } from "./Scenario";
import { upgradeCyoV1ToV2 } from "@/scenarios/upgraders";

export function App({ scenario }: { scenario: Scenario }) {
  let [savedDesktopState, setSavedDesktopState] = useState<DesktopState | null>(null);
  let [savedEdState, setSavedEdState] = useState<EdState | null>(null);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  const handleSave = useCallback((desktopState: DesktopState, edState: EdState) => {
    localStorage.setItem(`desktopState-${scenario.id}`, JSON.stringify(desktopState));
    localStorage.setItem(`edState-${scenario.id}`, JSON.stringify(edState));
  }, []);

  useEffect(() => {
    let savedDesktopState = loadOrDefault<DesktopState>(`desktopState-${scenario.id}`, scenario.initialDesktopState);
    let savedEdState = loadOrDefault<EdState>(`edState-${scenario.id}`, scenario.initialEdState);
    let upgradedScenario = upgradeCyoV1ToV2({
      id: scenario.id,
      initialDesktopState: savedDesktopState,
      initialEdState: savedEdState
    })
    setSavedDesktopState(upgradedScenario.initialDesktopState);
    setSavedEdState(upgradedScenario.initialEdState);
  }, [scenario]);

  const handleWindowSizeChange = useCallback(() => {
      setScreenWidth(window.innerWidth);
  }, [setScreenWidth]);

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, [handleWindowSizeChange]);

  if (!savedDesktopState || !savedEdState) {
    return <div></div>;
  }

  if (screenWidth < 700) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-white text-2xl text-center px-12">
        You'll be needing a bigger screen for this one buddy.
        <br />
        <br />
        And a proper keyboard.
      </div>
    );
  }

  return (
    <Desktop
      scenario={scenario}
      savedDesktopState={savedDesktopState}
      savedEdState={savedEdState}
      onSave={handleSave}
    />
  )
}

export default App;
